import React from 'react';
import { InputChip } from '../../InputChip/InputChip';
import { AgentStepInput } from 'configuration-schemas/viewdefns/viewdefn';
import { AgentChat } from '../AgentChat/AgentChat';

interface AgentInputProps {
  step: AgentStepInput;
  onSelectionChanged?: (selection: string[]) => void;
  onDataLoaded?: () => void;
}

export const AgentInput = ({ step, onSelectionChanged, onDataLoaded }: AgentInputProps) => {
  const { inputType, configApi, text } = step;

  const renderInput = () => {
    switch (inputType) {
      case 'dropdown': {
        return <div />;
      }

      case 'dependentDropdown': {
        return <div />;
      }

      case 'text': {
        return <div />;
      }

      case 'validValuesChips': {
        if (!configApi) return <div />;
        return <InputChip configApi={configApi} onDataLoaded={onDataLoaded} onSelectionChanged={onSelectionChanged} />;
      }

      default:
        return null;
    }
  };

  // TODO add animated loading spinner
  return (
    <div>
      <AgentChat type="agent" message={text} />
      {renderInput()}
    </div>
  );
};
